import { Map as AzMap } from 'azure-maps-control';

const initializedMaps = new Map();

export const findMap = (mapId) => initializedMaps.get(mapId);

export const assembleMap = (mapId, mapConfig) => {

    const mapDom = mapId?.tagName ? mapId : document.getElementById(mapId);
    let map = initializedMaps.get(mapId);
    if (map && mapDom) {
        return map;
    }

    if (!!!mapDom) {
        const mapPlaceholder = document.createElement('div');
        mapPlaceholder.id = mapId;
        mapPlaceholder.className += "min-h-screen map";
        const mapContainer = document.getElementById("mapContainer");
        mapContainer.prepend(mapPlaceholder);
    }

    mapConfig ??= () => { throw new Error('No mapConfig was provided'); };

    const longigute = mapConfig.longigute ?? 6;
    const latitude = mapConfig.latitude ?? 35;
    const { authOptions } = mapConfig;

    authOptions ??= () => { throw new Error('No authOptions were provided'); };


    if (authOptions.authType == 'anonymous') {
        authOptions.getToken = (resolve, reject, map) => fetch(authOptions.tokenServiceUrl).then((response) => response.text()).then(token => resolve(token));
    }

    map = new AzMap(mapId, {
        center: [longigute, latitude],
        zoom: mapConfig.zoom || 2,
        minZoom: mapConfig.minZoom || 1.5,
        maxZoom: mapConfig.maxZoom || 14,
        showFeedbackLink: false,
        showLogo: false,
        renderWorldCopies: true,
        maxBounds: [-180, -90, 180, 90],
        view: 'Auto',
        language: "en-GB",
        dragRotateInteraction: false,
        style: mapConfig.style ?? "road_shaded_relief",
        authOptions,
        enableAccessibilityLocationFallback: false
    })

    map.events.add('ready', function () { map.resize(); });
    initializedMaps.set(mapId, map);
    return map;
}